import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { MenuItem } from "@headlessui/vue";
import { PencilIcon } from "@heroicons/vue/24/solid";
import { computed, ref, provide } from "vue";
import { useTrackEvent } from "shared/composables/tracking";
import { useReports } from "@/composables/report";
import { DashboardGridSize } from "@/types/Dashboard";
import { Report } from "@/types/Report";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import EditReportModal from "@/views/reports/components/EditReportModal.vue";
import ReportPlot from "@/views/reports/components/ReportPlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportWidget',
  props: {
    arg: {},
    width: {},
    height: {},
    dashboardGridSize: {}
  },
  emits: ["widgetRouteClicked", "trackInteraction"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { reports, isLoading: areReportsLoading } = useReports();

const editedReport = ref<Report | null>(null);
const useWhiteIcons = ref(false);
const isWidgetLoading = ref(false);

provide("loadingStateEmitterRef", isWidgetLoading);

const report = computed(() => reports.value.find(({ _id }) => _id === props.arg));

const trackEvent = useTrackEvent();

const handleEditReportClick = () => {
  if (!report.value) {
    return;
  }
  editedReport.value = report.value;
  trackEvent("dashboard_widget_report-edit_click", { type: report.value.type });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: _unref(areReportsLoading) || isWidgetLoading.value,
    showContentOnLoading: isWidgetLoading.value,
    showZoomIcon: true,
    useWhiteIcons: useWhiteIcons.value,
    onTrackInteraction: _cache[4] || (_cache[4] = ($event: any) => (emit('trackInteraction', report.value?.type)))
  }, {
    menuItems: _withCtx(() => [
      _createVNode(_unref(MenuItem), { onClick: handleEditReportClick }, {
        default: _withCtx(({ active }) => [
          _createElementVNode("div", {
            class: _normalizeClass([
            active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
            'px-4 py-2 text-sm cursor-pointer truncate flex items-center gap-2',
          ])
          }, [
            _createVNode(_unref(PencilIcon), { class: "w-5 h-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("analytics.reports.edit_report")), 1)
          ], 2)
        ]),
        _: 1
      })
    ]),
    modals: _withCtx(() => [
      (editedReport.value)
        ? (_openBlock(), _createBlock(EditReportModal, {
            key: 0,
            report: editedReport.value,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (editedReport.value = null)),
            onDone: _cache[3] || (_cache[3] = ($event: any) => (editedReport.value = null))
          }, null, 8, ["report"]))
        : _createCommentVNode("", true)
    ]),
    zoomedView: _withCtx(({ height }) => [
      (report.value)
        ? (_openBlock(), _createBlock(ReportPlot, {
            key: 0,
            report: report.value,
            title: report.value.name,
            hidePopover: true,
            width: _ctx.width,
            height: height,
            hideLegend: true,
            spacingX: 16,
            spacingY: 12,
            dashboardGridSize: _ctx.dashboardGridSize
          }, null, 8, ["report", "title", "width", "height", "dashboardGridSize"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (report.value)
        ? (_openBlock(), _createBlock(ReportPlot, {
            key: 0,
            report: report.value,
            title: report.value.name,
            hidePopover: true,
            width: _ctx.width,
            height: _ctx.height,
            hideLegend: true,
            spacingX: 16,
            spacingY: 12,
            dashboardGridSize: _ctx.dashboardGridSize,
            isOnTheDashboard: true,
            onUpdateUseWhiteIcons: _cache[0] || (_cache[0] = ($event: any) => (useWhiteIcons.value = $event)),
            onWidgetRouteClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('widgetRouteClicked', report.value.type)))
          }, null, 8, ["report", "title", "width", "height", "dashboardGridSize"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isLoading", "showContentOnLoading", "useWhiteIcons"]))
}
}

})